import getCandidate from "./getCandidate";
import getDetailedClassRoomInformation from "./getDetailedClassRoomInformation";
import getStudentPanel from "./getStudentPanel";
import getStartTestTutomat from "./getStartTestTutomat";
import getStopTestTutomat from "./getStopTestTutomat";

export default {
    getCandidate,
    getDetailedClassRoomInformation,
    getStudentPanel,
    getStartTestTutomat,
    getStopTestTutomat
}